import React, { Component } from 'react';
import ReactTable from "react-table";
import "react-table/react-table.css";

class RankingPanel extends Component {
  render() {
    const data = this.props.rankingList

    const columns = [{
        Header: 'userId',
        accessor: 'userId' // String-based value accessors!
      }, {
        Header: 'avgScore',
        accessor: 'avgScore',
      }]

    return (
      <ReactTable data = {data} 
      columns = {columns} 
      showPagination = {false}
      defaultPageSize = {10}
      sortable = {false}>
      </ReactTable>
      );
  }
}

export default RankingPanel;



// WEBPACK FOOTER //
// ./src/components/rankingPanel.js